var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebit = function SvgDebit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    d: "M29.583 6c.641 0 1.256.258 1.709.716A2.46 2.46 0 0 1 32 8.444v17.112a2.46 2.46 0 0 1-.708 1.728 2.4 2.4 0 0 1-1.709.716H5.417c-.641 0-1.256-.258-1.709-.716A2.46 2.46 0 0 1 3 25.556V8.446c0-.648.255-1.27.708-1.728a2.4 2.4 0 0 1 1.709-.716zm1.209 9.781H4.208v9.782c0 .324.128.635.355.864s.533.358.854.358h24.166c.32 0 .628-.13.855-.358.226-.23.353-.54.354-.864v-9.785zM12.67 21.89v1.222H6.63V21.89zm15.703-2.445v1.223H24.75v-1.223zm-12.083 0v1.223H6.62v-1.223zM4.207 12.111v2.445H30.79V12.11zM30.79 10.89V8.446a1.23 1.23 0 0 0-.354-.864 1.2 1.2 0 0 0-.854-.358H5.417c-.32 0-.628.13-.854.358a1.23 1.23 0 0 0-.355.864v2.445z"
  })));
};
export default SvgDebit;